import { ZIPCODES_REGIONAL } from "../constants/DeliveryConstants";

export const parseZipPrefix = (zip) => {
  if (!zip) return null;
  const match = String(zip).match(/\d{4}/);
  return match ? parseInt(match[0], 10) : null;
};

export const isLandelijk = (zip) => {
  const prefix = parseZipPrefix(zip);
  if (!prefix) return true; // treat unknown as landelijk until specified
  return !ZIPCODES_REGIONAL.includes(prefix);
};
